(function () {
    'use strict';

    angular
        .module('app.promos')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
          {
              state: 'promos',
              abstract: true,
              config: {
                  url: '/promos',
                  template: '<ui-view/>',
                  settings: {
                      authMode: 1
                  },
                  resolve: {
                      authenticationRequired: ['userService', function (userService) {
                          userService.isAuthenticatedThrowError();
                      }]
                  }
              }
          },
          {
              state: 'promos.details',
              config: {
                  url: '/detail/:id',
                  templateUrl: 'app/promos/details.html?v=' + opsIncludeVersion,
                  controller: 'PromoDetailController',
                  controllerAs: 'vm',
                  title: 'Promo Help',
                  settings: {},
                  resolve: {
                      is7Point: ['userService', function(userService) {
                          if (userService.tenantId() != "1") {
                              throw { name: "NotAdmin" };
                          }
                      }]
                  }
              }
          }
        ];
    }
})();
